<template>
  <div class="tx-12 align-items-center d-flex bd-l">
    <!-- {{f.flag}} -->
    <div
      v-if="f.flag == 1"
      :title="t[f.field]"
      :class="`pd-x-5 wd-100p tx-color-${getColorCls()} tx-12`"
      style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
    >
      {{ t[f.field] }}
    </div>
    <div v-else-if="f.flag == 2" class="pd-x-5 wd-100p">
      <div
        v-if="t[f.field] > 0"
        style="color: #3f8b44"
        class="text-right o-w-b tx-medium tx-12 tx-roboto"
      >
        {{ t[f.field] | formatMoney(0, ".", ",") }}
      </div>
      <div
        v-else-if="t[f.field] == 0"
        class="text-right o-w-b tx-roboto tx-11 tx-color-04"
      >
        {{ t[f.field] | formatMoney(0, ".", ",") }}
      </div>
      <div
        v-else-if="t[f.field] < 0"
        style="color: #f44336"
        class="text-right o-w-b"
      >
        {{ t[f.field] | formatMoney(2, ".", ",") }}
      </div>
    </div>
    <div v-else-if="f.flag == 3" class="pd-x-5 text-muted">
      {{ t[f.field] | moment("YYYY.MM.DD HH:mm") }}
    </div>
    <div class="pd-xs wd-100p" v-else-if="f.flag == 6">
      <div>
        <template v-if="t.st1 != undefined">
          <b style="color: #444" v-if="t.st1 != ''" class="pd-r-5">{{
            t.st1
          }}</b>
        </template>
        <b style="color: #444" v-else class="pd-r-5">{{ t.prefix }}</b>
        <span>{{ t.task }}</span>
      </div>
    </div>
    <div class="pd-xs wd-100p text-right" v-else-if="f.flag == 10">
      {{ t[f.field] | moment("YYYY") }}
    </div>
    <div v-else-if="f.flag == 11" class="pd-x-5 wd-100p" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
      {{ showObj(t, f.field) }}
    </div>
    <div v-else-if="f.flag == 18" class="pd-x-5  text-center wd-100p">
      <!-- <button
        v-if="t[f.field] > 0"
        @click.stop="$emit('on-attach', t[f.field])"
        type="button"
        class="btn btn-xs btn-success btn-block pd-t-1 pd-b-1"
      >
        харах
      </button>
       -->
       <div @click.stop="$emit('on-attach', t[f.field])" class="bg-gray-50 rounded bd bd-gray-100" v-if="t[f.field] > 0">
        <feather type="link-2" class="text-gray-900"></feather>
       </div>
    </div>
    <div v-else-if="f.flag == 17" class="pd-xs">
      <div v-if="t.pinnedUserCount > 0">
        <!-- @click="showPinnedUsers()"  -->
        <a
          :title="t.pinnedUserCount + ' хэрэглэгч идэвхитэй байна'"
          class="ff-ibm-plex"
        >
          <b>{{ t.pinnedUserCount }}</b>
          <sup>
            <i
              class="m-l-xs ivu-icon ivu-icon-ios-people"
              style="font-size: 12px"
            ></i>
          </sup>
        </a>
      </div>
    </div>
    <div v-else-if="f.flag == 19" class="pd-x-5 text">
      <template v-if="t[f.field].task != null && t[f.field].task != ''">
        <template v-if="listSetting!=undefined && listSetting!=null && listSetting.chooser"
        >
          {{ t[f.field]["task"] }}
        </template>
        <div v-else role="button" class="tx-brand-01 " @click.stop="$emit('show-detail', { obj: t[f.field], mode: 80 })">
          <feather type="external-link" class="wd-15 ht-15 mg-r-5"></feather>
          <span class="tx-color-03">{{ t[f.field]["task"] }}</span>
        </div>
      </template>
    </div>
    <div v-else-if="f.flag == 21" class="pd-xs text-right">
      <span style="color: green" v-if="t[f.field] >= 0">{{
        t[f.field] | formatMoney(",", ".")
      }}</span>
      <span style="color: red" v-if="t[f.field] < 0">{{
        (t[f.field] * -1) | formatMoney(",", ".")
      }}</span>
    </div>
    <div
      v-else-if="f.flag == 22"
      class="text-center wd-100p"
      @click.stop="updateField(f)"
    >
      <!-- <b-icon class="wd-32 ht-32" @click.stop="$emit('on-update-field', { taskId: t.id, field: { field: f.field }, value: t[f.field], mode: 0 }); t[f.field]=!t[f.field]" :icon="t[f.field] ? 'check-square' : 'square'"></b-icon> -->
      <div :class="`tx-color-${t[f.field] ? '03' : '04'}`" role="button">
        <feather :type="t[f.field] ? 'check-square' : 'square'" ></feather>
      </div>
    </div>
    <div v-else-if="f.flag == 25" class="text-left wd-100p pd-l-5">
      <div v-if="t.isTender" class="lh-1 tx-10 d-flex align-items-center">
        <!-- <img    :src="$config.paymentOptnios.filter(x=>x.id==t.systemFlag)[0].icon" :title="$config.paymentOptnios.filter(x=>x.id==t.systemFlag)[0].title" 
        style="width: 16px; height: 16px" class="m-r-xs" />-->
        <img :src="getPayIcon(t.systemFlag)" style="width: 16px; height: 16px" class="mg-r-5" />
        <div>Төлсөн {{ t.s16 }}</div>
      </div>
      <span v-else>
        Төлөөгүй
        <button
          v-if="
            t.isTender != true &&
              hasPermission(['cashAdminAAA111', 'cashadmin', 'admin'])
          "
          type="button"
          class="btn btn-xs btn-outline-primary"
          style="padding: 0px 4px; line-height: 1; height: 20px"
          @click.stop="payByCash()"
        >
          Бэлнээр төлөх
        </button>
      </span>
    </div>
    <div v-else-if="f.flag == 26" class="pd-xs text-center wd-100p">
      <div :class="`text-center tx-color-0${t[f.field] == 'true' || t[f.field] == '1'?'3':'4'}`">
        <feather
          v-if="t[f.field] == 'true' || t[f.field] == '1'"
          type="check-square"
        ></feather>
        <feather v-else type="square"></feather>
        <!-- <i v-if="value=='true'|| value=='1'" class="ivu-icon ivu-icon-md-checkbox-outline" style="font-size: 20px;"></i>
        <i v-else class="ivu-icon ivu-icon-md-square-outline" style="font-size: 20px; color: #99a6ad"></i>-->
      </div>
    </div>
    <div
      v-else-if="f.flag == 30"
      style="
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #ff9800;
      "
      class="text-right p-xxs"
      :title="t[f.field] | moment('LLLL')"
    >
      {{ t[f.field] | moment("YYYY-MM-DD HH:mm") }}
    </div>
    <div v-else-if="f.flag == 31" class="pd-xs text-right wd-100p">
      <template v-if="t.isTender">
        <span style="color: green">Төлөгдсөн</span>
      </template>
      <span v-else>
        <span style="color: red">Төлөгдөөгүй</span>
        <!-- <button type="button" class="ivu-btn ivu-btn-default ivu-btn-small" @click="$emit('on-show-my-invoice-box')" >
          <span>
            <i class="ivu-icon ivu-icon-ios-card-outline"></i>
            Төлөх
          </span>
        </button> -->
      </span>
    </div>
    <template v-else-if="f.flag == 32">
      <template v-if="$store.state.app.activeGroup.id == 9237">
        <div
          v-if="t.column != null"
          class="
            d-flex
            wd-100p
            align-items-center
            justify-content-between
            bg-light
          "
        >
          <div
            :title="c.column"
            :key="i"
            v-for="(c, i) in projectStat.columns"
            :style="
              `${borderBg(t, i)}; width: ${100 / projectStat.columns.length}%`
            "
            :class="`tx-11 text-center ${i > 0 ? 'bd-l' : ''}`"
          >
            {{ c.column.charAt(0) }} 
            <template v-if="i + 1 < t.columnOrd"></template>
            <template v-else-if="i + 1 == t.columnOrd">
              <span v-if="isDateBefore(nowDate, t.column.dueDate) && t.k != '00:00:00'"
                >[{{ t.k }}]</span>
              <sup
                v-else
                :title="
                  `Хугацаа хэтрээд: ${showExpDate(t.column.dueDate, nowDate)}`
                "
                ><feather
                  type="bell"
                  style="height: 12px !important; width: 12px !important"
                  class="text-danger"
                ></feather
              ></sup>
            </template>
            <template v-else-if="i + 1 > t.columnOrd"></template>
          </div>
        </div>
        <div v-else-if="t.isCompleted" class="pd-x-5 wd-100p">
          <feather
            type="check"
            style="font-size: 12px"
            class="tx-success"
          ></feather>
          {{ t.completedAt | moment("YYYY.MM.DD HH:mm, dddd") }}
        </div>
      </template>
      <template v-else>
        <!-- 
        STEP ee asset tai holbootoi shinechlev 2021.11.02
         -->
        <template v-if="t.column != null">
          <div
            :id="`popover-reactive-${t.id}`"
            class="mg-x-5 progress ht-20 wd-100p"
            @click.stop="$emit('on-popover', t)"
          >
            <div
              :title="c.column"
              :key="i"
              v-for="(c, i) in projectStat.columns"
              :class="
                `progress-bar tx-10 ${
                  projectStat.columns.length > i + 1 ? 'bd-r' : ''
                } ${columnBg(t, i)}`
              "
              :style="{ width: (100 * t.columnOrd) / t.column.count + '%' }"
              role="progressbar"
            >
              <template v-if="isDateBefore(t.dueDate, nowDate)">
                <b-icon icon="alarm"></b-icon>
              </template>
              <template v-else>{{ c.column.charAt(0) }}</template>
            </div>
          </div>
        </template>
        <div v-else-if="t.isCompleted" class="pd-x-5 wd-100p">
          <feather
            type="check"
            style="font-size: 12px"
            class="tx-success"
          ></feather>
        </div>
      </template>
    </template>
    <div
      style="
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 500;
      "
      class="text-right ff-ibm-plex pd-xxs wd-100p"
      v-else-if="f.flag == 33"
    >
      <!-- v-bind:class="{ 'text-muted': value<=0 }" -->
      {{ t[f.field] }}
    </div>
    <div v-else-if="f.flag == 34" class="pd-x-5 tx-color-04 tx-11 d-flex align-items-center justify-content-center wd-100p">
      {{ t[f.field] | moment("YYYY.MM.DD") }}
    </div>
    <div
      @click.stop="$emit('on-user-info', t.user.id)"
      v-else-if="f.flag == 35" style="cursor: zoom-in;"
      class="d-flex align-items-center pd-l-5 wd-100p"
    >
      <div class="">
        <img :src="t['user']['avator']" class=" rounded" style="width: 15px" />
      </div>
      <div class="mg-x-3" style="overflow: hidden">
        <div class="tx-11 tx-color-03">{{ t["user"]["fullName"] }}</div>
        <!-- <div class="tx-8 text-muted">{{ t["user"]["position"] }}</div> -->
      </div>
    </div>
    <div
      v-else-if="f.flag == 38"
      class="pd-x-5 text d-flex wd-100p justify-content-between"
    >
      <template v-if="t.user != null">
        <div
          class="text-muted"
          style="
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            cursor: pointer;
          "
          :title="t.user.departName + ' ' + t.user.position"
        >
          {{ t.user.departName }}
          <!-- <i v-if="t.user.departName!=null" class="ivu-icon ivu-icon-ios-arrow-forward"></i> -->
          <feather
            v-if="t.user.departName != null"
            size="14"
            type="chevron-right"
          ></feather>
          {{ t.user.position }}
        </div>
      </template>
    </div>
    <div
      v-else-if="f.flag == 39"
      class="wd-100p text-truncate"
      @click.stop="$emit('on-user-info', t.user.id)"
    >
      <a class="tx-primary"
        v-if="t.user != null"
        :title="t.user.lastName + '-н ' + t.user.firstName"
      >
        <img
          :src="t.user.avator"
          class="m-r-xxs"
          style="border-radius: 5px; width: 16px; height: 16px"
        />
        {{ t.user.fullName }}
      </a>
    </div>
    <div
      v-else-if="f.flag == 40"
      style="
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
      "
      class="pd-x-5 wd-100p text-truncate"
    >
      <!-- <a @click="handleUserCompose({ id: task.id, attachid: 0 })" v-if="task.user != null" :title="task.user.fullName+'-н ['+task.user.email+'] руу шинэ и-мэйл илгээх'">
        {{task.user.email}}
      </a>-->
      <span class="tx-primary" v-if="t.user != null">{{ t.user.email }}</span>
    </div>
    <div
      v-else-if="f.flag == 41"
      style="
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
      "
      class="wd-100p text-truncate ht-100p"
    >
      <member-point
        @on-show-point="
          $emit('on-show-point', { task: t, sumPoint: t.memberPoint })
        "
        :task="t"
        :sumPoint="t.memberPoint"
      />
    </div>
    <div v-else-if="f.flag == 43" class="wd-100p" @click.stop>
      <simple-uploader
        v-model="t[f.field]"
        :propBoxId="0"
        :propObjectId="'0'"
        :propObjectTypeId="t['objectTypeId']"
        @on-success="fileUploaded($event, f)"
        class="mg-t-3"
      >
        <div slot="trigger" class="wd-100p">
          <div class="btn-group wd-100p" v-if="t[f.field] > 0">
            <button
              @click.stop="$emit('on-attach', t[f.field])"
              type="button"
              class="btn btn-xs btn-primary"
            >
              <feather type="paperclip"></feather>харах
            </button>
            <button
              @click.stop="fileRemoved(t, f)"
              type="button"
              class="btn btn-xs btn-danger"
            >
              <feather type="x"></feather>хасах
            </button>
          </div>
          <div v-else class="btn-group wd-100p">
            <button type="button" class="btn btn-xs btn-outline-success">
              <feather type="upload"></feather>Компютероос
            </button>
            <button
              @click.stop="
                $emit('link-drive', { taskId: t.id, field: f.field })
              "
              type="button"
              class="btn btn-xs btn-outline-primary"
            >
              <feather type="archive"></feather>Драйваас
            </button>
          </div>
        </div>
      </simple-uploader>
    </div>
    <div v-else-if="f.flag == 45" class="wd-100p go-cell-ellps p-l-xs">
      <div @click="$emit('on-show-tags', t)" class="is-pointer">
        <template v-if="t.tagList != null">
          <template v-if="t.tagList.length > 0">
            <span
              title="1+"
              v-if="t.tagList.length > 1"
              :style="
                `margin-right: 2px; border-radius: 5px;color: white; text-transform: lowercase; padding: 0px 3px 2px 3px; font-size: 10px; background: gray`
              "
              >+{{ t.tagList.length - 1 }}</span
            >
            <span
              :key="tgi"
              :title="tg.name"
              v-for="(tg, tgi) in t.tagList"
              :style="
                `margin-right: 2px; border-radius: 5px;color: white; text-transform: lowercase; padding: 0px 3px 2px 3px; font-size: 10px; background: ${tg.value}`
              "
              >{{ tg.name }}</span
            >
          </template>
        </template>
        <div v-else title="Хавчуулах ?" class="text-center">
          <tag-icon size="12" class="m-t-sm"></tag-icon>
        </div>
      </div>
      <!-- <section :key="tgi" :title="tg.name" v-for="(tg, tgi) in task.tagList" style="float: left; cursor: help">
        <span class="ivu-tag-dot-inner" :style="`margin-right:1px; top: 0px; position: absolute; width: 6px; height: 6px; background: ${tg.value}`"></span>
        <span class="p-l-xs m-r-xs text-muted" style="text-transform: lowercase">{{tg.name.slice(0,2)}}</span>
      </section>-->
    </div>
    <div
      v-else-if="f.flag == 50"
      class="wd-100p text-truncate"
      @click.stop="$emit('on-user-info', t.secondUser.id)"
    >
      <a
        v-if="t.secondUser != null"
        :title="t.secondUser.lastName + '-н ' + t.secondUser.firstName"
      >
        <img
          :src="t.secondUser.avator"
          class="m-r-xxs"
          style="border-radius: 5px; width: 16px; height: 16px"
        />
        {{ t.secondUser.fullName }}
      </a>
    </div>
    <div
      v-else-if="f.flag == 51"
      style="
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #ff9800;
      "
      class="text-right p-xxs"
      :title="t[f.field] | moment('LLLL')"
    >
      {{ t[f.field] | moment("YYYY-MM") }}
    </div>
    <div v-else-if="f.flag == 52" class="wd-100p" v-html="isInTime()"></div>
    <div v-else-if="f.flag == 54" class="wd-100p text-truncate pd-x-5">
      <template
        v-if="
          t.pinnedUsers != undefined &&
            t.pinnedUsers != null &&
            t.pinnedUsers.length
        "
      >
        <div
          v-if="t.pinnedUsers.length > 1"
          :title="`${t.pinnedUserCount} хэрэглэгч идэвхитэй байна.`"
          class="img-group is-pointer"
        >
          <img
            @click.stop="$emit('on-user-info', pu.id)"
            v-for="(pu, i) in t.pinnedUsers"
            :key="i"
            :src="pu.avator"
            :title="pu.fullName"
            class="img wd-20 ht-20 rounded-circle pd-0-f mg-l-0-f"
          />
        </div>
        <a
          v-else
          @click.stop="$emit('on-user-info', t.pinnedUsers[0].id)"
          :style="`color: ${getDocMyColor(t)}`"
          >{{ t.pinnedUsers[0].fullName }}</a
        >
      </template>
    </div>
    <div v-else-if="f.flag == 55" class="wd-100p pd-xs">
      <span class="tx-info" v-show="t.i1 == 1">баталгаажсан</span
      ><span class="tx-warning" v-show="t.i1 == 0">шинэ</span
      ><span v-show="t.i1 == 2" class="tx-success">буцаан авсан</span
      ><span class="tx-danger" v-show="t.i1 == -1">цуцалсан</span>
    </div>
    <div v-else-if="f.flag == 57" class="wd-100p text-truncate pd-x-5">
      <template
        v-if="
          t.sharedUsers != undefined &&
            t.sharedUsers != null &&
            t.sharedUsers.length
        "
      >
        <div
          v-if="t.sharedUsers.length > 1"
          :title="`${t.sharedUsers.length} хэрэглэгч идэвхитэй байна.`"
          class="img-group is-pointer"
        >
          <img
            @click.stop="$emit('on-user-info', pu.id)"
            v-for="(pu, i) in t.sharedUsers"
            :key="i"
            :src="pu.avator"
            :title="pu.fullName"
            class="img wd-20 ht-20 rounded-circle pd-0-f mg-l-0-f"
          />
        </div>
        <a
          v-else
          @click.stop="$emit('on-user-info', t.sharedUsers[0].id)"
          :style="`color: ${getDocMyColorFromShared(t)}`"
          >{{ t.sharedUsers[0].fullName }}</a
        >
      </template>
    </div>
    <div v-else-if="f.flag == 58" class="wd-100p pd-xs">
    </div>
    <div v-else-if="f.flag == 59" class="wd-100p d-flex align-items-center justify-content-center" @click.stop>
      <a class="btn btn-xs btn-white mg-x-xs" 
      @click.stop="$emit('on-update-field', {
          taskId: t.id,
          field: { field: f.field },
          value: t[f.field],
          mode: 59
        })">{{t[f.field]!=undefined && t[f.field]!=null && t[f.field]!=''?t[f.field]:0}}</a>
    </div>
    <div v-else-if="f.flag == 60" class="wd-100p d-flex align-items-center justify-content-center" @click.stop>
      <a class="btn btn-xs btn-white mg-xs" 
       @click.stop="$emit('on-update-field', {
          taskId: t.id,
          field: { field: f.field },
          value: t[f.field],
          mode: 59
        })">{{t[f.field]!=undefined && t[f.field]!=null && t[f.field]!=''?t[f.field]:0}}</a>
    </div>
    <div v-else-if="f.flag == 61" v-html="getStatStf(t,f)" class="pd-3">
      
    </div>
    <div v-else class="text-muted">{{ f.flag }}</div>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
const moment = require("moment");
import { hasOneOf } from "@/libs/tools";
import { request } from "@/api/all";

export default {
  components: {
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    memberPoint: () => ({
      component: import(
        "@/components/task/list/components/memberPoint/memberPoint.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 300,
      timeout: 5000
    })
  },
  props: {
    f: {
      type: Object,
      default: () => {}
    },
    t: {
      type: Object,
      default: () => {}
    },
    projectStat: {
      type: Object,
      default: () => {}
    },
    nowDate: {
      type: String,
      default: () => ""
    },
    parentTask: {
      type: Object,
      default: () => {}
    },
    listSetting: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      // date: moment(60 * 10 * 1000),
      // dateLocal: null,
      cellintval: null
    };
  },
  computed: {
    //  timeDown: function(dueDate){
    //    //console.log(dueDate);
    //   return this.dateLocal.format('mm:ss');
    // }
  },
  mounted() {
    //console.log('this t',this.t.columnt);
    if (this.f.flag == 32 && (this.isDateBefore(this.nowDate, this.t.dueDate) && this.t.column!=undefined && this.t.dueDate!=undefined && this.t.dueDate!=null)) {
      this.dateLocal = this.nowDate;
      // setInterval(() => {
      //   this.dateLocal = moment(moment(this.nowDate).subtract(1, 'seconds'))
      // }, 1000);
      //   this.date = moment(this.date.subtract(1, 'seconds'))
      // }, 1000);
      var i = 0;
      this.cellintval = setInterval(() => {
        i++;
        this.t.k = this.getRemain(
          moment(this.t.column.dueDate).subtract(i, "seconds")
        );
      }, 1000);
    }
  },
  beforeDestroy() {
    //console.log(this.cellintval)
    //console.log('beforeDestroybeforeDestroybeforeDestroybeforeDestroybeforeDestroybeforeDestroybeforeDestroybeforeDestroybeforeDestroybeforeDestroybeforeDestroybeforeDestroybeforeDestroybeforeDestroybeforeDestroy');
    clearInterval(this.cellintval);
    //console.log(this.cellintval)
  },
  updated() {},
  methods: {
    getColorCls(){
      let rv= '02';
      if(this.t.objectTypeId==115) {
        console.log('q1');
        if(this.t.isPublic!=undefined && this.t.isPublic){
          rv='02';
        }else{
          rv='03';
        }
      }
      return rv;
      // t.objectTypeId==115 && t['isPublic']?'02':'03'
    },
    getPayIcon(flag){
      let rv= '';
      if(flag==3){
        rv='https://res.gosmart.mn/media/logo/pay/qpay-small.png';
      }else if(flag==10){
        rv='https://res.gosmart.mn/media/logo/pay/money.png';
      }
      return rv;
    },
    getStatStf(t,f){
      let rv='';
      if(t[f.field]==777 || t[f.field]==6){
        rv=`<span class="badge badge-success" style="white-space: break-spaces">Шалгарсан [777]</span>`
      } else if(t[f.field]==-777 || t[f.field]==10){
        rv=`<span class="badge badge-error" style="white-space: break-spaces">Шалгараагүй [-777]</span>`
      } else if(t[f.field]==-1){
        rv=`<span class="badge badge-warning" style="white-space: break-spaces">Бүртгэл хийж буй [-1]</span>`
      } else if(t[f.field]==1){
        // rv=`<span class="badge badge-info" style="white-space: break-spaces">ШУТСанд, БОЯд илгээгдсэн</span>`
        if(t['days']==2){
          rv=`<span class="badge badge-info" style="white-space: break-spaces">Шинжээч томилсон [1]</span>`
        }else{
          rv=`<span class="badge badge-info" style="white-space: break-spaces">ШУТСанд илгээгдсэн [1]</span>`
        }
      } else if(t[f.field]==2){
        // if(t['days']==2){
        //   rv=`<span class="badge badge-info" style="white-space: break-spaces">Шинжээч томилсон</span>`
        // }else{
        //   rv=`<span class="badge badge-info" style="white-space: break-spaces">ШУТПаркад илгээгдсэн</span>`
        // }
        rv=`<span class="badge badge-info" style="white-space: break-spaces">Шинжээч томилсон [2]</span>`
        
      }
      else{
        rv=t[f.field];
      }
      return rv;
    },
    getRemain(dueDate) {

      var now  = dueDate;
      var then = this.dateLocal;

      var ms = moment(now,"DD/MM/YYYY HH:mm:ss").diff(then);
      //console.log('ms', ms);
      var d = moment.duration(ms);
      var s = Math.floor(d.asHours()) + moment.utc(ms).format(":mm:ss");

      return s;

      // var duration = moment
      //   .utc(moment(dueDate).diff(this.dateLocal))
      //   .format("DD:hh:mm:ss");
      // //var hours = duration.asHours();
      // return duration; // moment(moment(this.nowDate,"DD/MM/YYYY HH:mm:ss").diff(moment(dueDate,"DD/MM/YYYY HH:mm:ss"))).format("mm:ss")
    },
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    payByCash() {
      var desc = prompt("Тайлбар оруулна уу", "");
      if (desc != null) {
         let link = "Payment/payByCash";
        if(this.t.objectTypeId==532)
          link = "Payment/PayPackageInvoiceByCash";

        request({
          api: { method: "post", url: link },
          data: { invoiceId: this.t.id, desc: desc },
          store: this.$store
        }).then(res => {
          if (res != false) {
            this.$emit("on-update-field", {
              taskId: this.t.id,
              field: this.f,
              value: "",
              mode: 1
            });
          }
        });
      }
    },
    borderBg(t, i) {
      let rv = "";
      if (t.columnOrd <= i + 1) {
        if (t.columnOrd == i + 1) {
          if (this.isDateBefore(t.dueDate, this.nowDate)) {
            rv = "border-bottom:2px solid red";
          } else {
            rv = "border-bottom:2px solid orange";
          }
        } else {
          //rv = "gray";
        }
      } else {
        rv = "border-bottom:2px solid green";
      }
      return "" + rv;
    },
    columnBg(t, i) {
      let rv = "";
      if (t.columnOrd <= i + 1) {
        if (t.columnOrd == i + 1) {
          if (this.isDateBefore(t.dueDate, this.nowDate)) {
            rv = "bg-danger";
          } else {
            rv = "bg-warning-light";
          }
        } else {
          rv = "bg-white text-muted";
        }
      } else {
        rv = "bg-success-light";
      }
      return rv;
    },
    isDateBefore(d1, d2) {
      //console.log(d1, d2);
      return moment(d1).isBefore(d2);
    },
    showExpDate(d1, d2) {
      var duration = moment.utc(moment(d2).diff(d1)).format("HH:mm:ss");
      return duration;
    },
    showObj(t, f) {
      let arr = f.split(".");
      return t[arr[0]][arr[1]];
    },
    fileUploaded(e, field) {
      // field.uv = false;
      // this.t[this.f.key] = e.uploadedName;
      // this.t[this.f.field] = e.uploadedAttachmentId;
      // field.cstmFld1 = e.uploadedUrl;
      // this.featherReplace();
      //this.$emit("on-update-field", { taskId: this.t.id, field: { field: field.field }, value: e.uploadedAttachmentId, mode: 2 });
      this.$emit("on-update-field", {
        taskId: this.t.id,
        field: { field: field.field },
        value: e.uploadedAttachmentId,
        mode: 22
      });
    },
    fileRemoved(t, field) {
      // this.t[field.field]=null;
      // this.t[field.key]='';
      //if(this.parentTask.im!=null && this.parentTask.im.pinIs){
      this.$emit("on-update-field", {
        taskId: this.t.id,
        field: { field: field.field },
        value: null,
        mode: 2
      });
      // }else{
      //   this.$bvToast.toast('Үйлдлийг гүйцэтгэх боломжгүй', { title: "Мэдэгдэл", autoHideDelay: 3000, appendToast: false, variant: "warning", toaster: "b-toaster-bottom-left"});
      // }
      //this.featherReplace();
    },
    infoBuilder(v) {
      if (v == null) {
        return "";
      } else if (v.length <= 0) {
        return "";
      } else {
        return v;
      }
    },
    updateField(f) {
      //console.log('sdf', f, hasOneOf(f.key.split(","), this.$store.state.user.access));
      if (hasOneOf(f.key.split(","), this.$store.state.user.access)) {
        this.$emit("on-update-field", {
          taskId: this.t.id,
          field: { field: f.field },
          value: this.t[f.field],
          mode: 0
        });
      } else {
        this.$bvToast.toast("Үйлдлийг гүйцэтгэх боломжгүй222", {
          title: "Мэдэгдэл",
          autoHideDelay: 5000,
          appendToast: false,
          variant: "warning",
          toaster: "b-toaster-bottom-left"
        });
      }
    },
    isInTime() {
      let rv = "";
      if (this.t["dueStartDate"] > this.nowDate) {
        rv = `<span class="badge badge-secondary">Хурал эхлэх | ${moment(
          this.t["dueStartDate"]
        ).format("MM-сар DD-н HHц:mmм")}</span>`;
      } else {
        if (this.t["dueDate"] > this.nowDate) {
          rv = '<span class="badge badge-warning">Хурал үргэлжилж байна</span>';
        } else {
          rv = `<span class="badge badge-success">Дууссан | ${moment(
            this.t["dueDate"]
          ).format("MM-сар DD-н HHц:mmм")}</span>`;
        }
      }
      return rv;
    },
    calculateRangeIsAlert(d1, d2) {
      return moment(d1).isBefore(d2);
    },
    getDocMyColor(t) {
      let rv = "rgb(158, 158, 158)";
      if (this.$store.state.user.userId == t.pinnedUsers[0].userId) {
        if (t.column != null) {
          if (this.calculateRangeIsAlert(t.dueDate, this.nowDate)) {
            if (t.objectTypeId == 157 && t.i1 == 1) {
              rv = "red";
            } else {
              rv = "#57a3f3";
            }
          }
        } else if (t.isCompleted) {
          rv = "green";
        }
      }
      return rv;
    },
    getDocMyColorFromShared(t) {
      let rv = "rgb(158, 158, 158)";
      if (this.$store.state.user.userId == t.sharedUsers[0].userId) {
        if (t.column != null) {
          if (this.calculateRangeIsAlert(t.dueDate, this.nowDate)) {
            if (t.objectTypeId == 157 && t.i1 == 1) {
              rv = "red";
            } else {
              rv = "#57a3f3";
            }
          }
        } else if (t.isCompleted) {
          rv = "green";
        }
      }
      return rv;
    }
  }
};
</script>
